export default __webpack_public_path__ + "static/media/B47ECD23-02CD-445B-B9D1-35606F77F2C2_1_105_c.f65aff1f.jpeg";